<template>
  <div>
    <v-checkbox
      @click.capture.native.prevent="setSimpleEditor($event)"
      label="Użyj edytora WYSIWYG tekstowego zamiast formularza"
      v-if="type !== 'other' && !$store.state.AdminTravelService.isOfferReadonly"
      v-model="contextServiceOffer.simpleEditor"
    />
    <v-row>
      <v-col md="9" v-if="contextServiceOffer.simpleEditor" cols="12">
        <custom-tinymce-editor :value.sync="contextServiceOffer.html" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col md="9" v-else cols="12">
        <div :key="partIndex" v-for="(part, partIndex) in contextServiceOffer.parts">
          <div v-if="type === 'flight'">
            <flight-form
              :baggage-rules="[isBaggageFieldRequired]"
              :part.sync="part"
              :part-index="partIndex"
              :return-route-checkbox-rules="[() => validateIsReturnRouteSet(contextServiceOffer)]"
              @returnRouteCheckboxReValidate="revalidateReturnRoute"
              :show-return-checkbox="returnDate != null"
              ref="toValidate"
            />
          </div>
          <div v-if="type === 'low-cost'">
            <low-cost-form
              :baggage-rules="[isBaggageFieldRequired]"
              :part.sync="part"
              :part-index="partIndex"
              @returnRouteCheckboxReValidate="revalidateReturnRoute"
              :return-route-checkbox-rules="[() => validateIsReturnRouteSet(contextServiceOffer)]"
              :show-return-checkbox="returnDate != null"
              ref="toValidate"
            />
          </div>
          <div v-if="type === 'car'">
            <car-form :part.sync="part" :part-index="partIndex" />
          </div>
          <div v-if="type === 'rail'">
            <rail-form
              :part.sync="part"
              :part-index="partIndex"
              :return-route-checkbox-rules="[() => validateIsReturnRouteSet(contextServiceOffer)]"
              @returnRouteCheckboxReValidate="revalidateReturnRoute"
              :show-return-checkbox="returnDate != null"
              ref="toValidate"
            />
          </div>
          <div v-if="type === 'hotel'">
            <hotel-form :part-index="partIndex" :part="part" />
          </div>
          <v-btn
            v-if="!$store.state.AdminTravelService.isOfferReadonly"
            @click.native="removeServicePart(partIndex)"
            button
            class="lighten-2"
            color="grey"
            fab
            small
            style="position: relative; top: -45px"
          >
            <v-icon>remove</v-icon>
          </v-btn>
        </div>
        <v-btn
          v-if="!$store.state.AdminTravelService.isOfferReadonly"
          @click.native="addServicePart(contextServiceOffer)"
          button
          color="primary"
          fab
          small
          style="position: relative; top: -84px; right: -40px;"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col md="2" cols="12">
        <slot />
      </v-col>
      <v-btn
        v-if="typeof removeServiceFunction === 'function' && !$store.state.AdminTravelService.isOfferReadonly"
        @click="removeServiceFunction(serviceOffer)"
        class="hidden-md-and-up"
      >
        Usuń aktualną opcję
      </v-btn>
    </v-row>
    <fieldset v-if="type === 'low-cost'" class="custom-fieldset">
      <legend>Załącz formułki dotyczące</legend>
      <v-row>
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Rayanair" v-model="contextServiceOffer.is_rayanair" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Wizz Air" v-model="contextServiceOffer.is_wizz_air" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Norwegian" v-model="contextServiceOffer.is_norwegian" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="easyJet" v-model="contextServiceOffer.is_easy_jet" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Germanwings / Eurowings" v-model="contextServiceOffer.is_germanwings" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Vueling" v-model="contextServiceOffer.is_vueling" />
        <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" label="Jet 2" v-model="contextServiceOffer.is_jet2" />
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import CustomTinymceEditor from "../../../CustomInputComponents/CustomTinymceEditor";
import FlightForm from "./FlightForm";
import CarForm from "./CarForm";
import RailForm from "./RailForm";
import HotelForm from "./HotelForm";
import LowCostForm from "./LowCostForm";
import travelServiceOrderItemPartFactory from "../../../../models/travelOrder/formPartFactory";
export default {
  name: "OfferItemForm",
  components: { LowCostForm, HotelForm, RailForm, CarForm, FlightForm, CustomTinymceEditor },
  props: {
    serviceOffer: {
      required: true
    },
    isBaggageFieldRequired: {
      required: true
    },
    removeServiceFunction: {
      required: false,
      default: null
    },
    type: {
      required: true,
      type: String
    },
    returnDate: {
      required: false,
      default: null
    }
  },
  methods: {
    revalidateReturnRoute() {
      console.log(this.$refs);
      for (let checkbox of this.$refs.toValidate) {
        checkbox.reValidateCheckbox();
      }
    },
    validateIsReturnRouteSet(item) {
      let toRoute = false;
      let fromRoute = false;
      for (let part of item.parts) {
        if (part.is_return_route === false) {
          toRoute = true;
        } else {
          fromRoute = true;
        }
      }
      return (toRoute && fromRoute) || "Wymagana jest przynajmniej jedna trasa tam i jedna powrotna";
    },
    addServicePart(serviceItem) {
      let formPart = travelServiceOrderItemPartFactory(this.type);
      serviceItem.parts.push(formPart);
    },
    removeServicePart(servicePartIndex) {
      if (this.serviceOffer.parts.length < 2) {
        this.$store.dispatch("snackbarPush", {
          text: "Opcja musi mieć przynajmniej jedną usługę",
          color: "error",
          position: "down"
        });
      } else {
        this.serviceOffer.parts.splice(servicePartIndex, 1);
      }
    },
    setSimpleEditor(event) {
      let simpleEditor = this.contextServiceOffer.simpleEditor;
      if (simpleEditor === false) {
        this.$store
          .dispatch("confirmDialog", {
            content:
              "Standardowo nie powinieneś korzystać z manualnego edytora WYSIWYG, " +
              "opcja ta dopuszczalna jest jedynie dla przypadków które wymagają innego formatu danych " +
              "lub predefiniowany formularz jest niewystarczający",
            title: "Ostrzeżenie"
          })
          .then(() => {
            this.contextServiceOffer.parts = [];
            this.contextServiceOffer.simpleEditor = true;
          });
      } else {
        this.contextServiceOffer.simpleEditor = false;
        this.contextServiceOffer.html = null;
        this.contextServiceOffer.parts = [];
        this.addServicePart(this.contextServiceOffer);
      }
      event.stopPropagation();
      event.preventDefault();
    }
  },
  computed: {
    contextServiceOffer: {
      get() {
        return this.serviceOffer;
      },
      set(val) {
        this.$emit("update:serviceOffer", val);
      }
    }
  }
};
</script>

<style scoped />
